import LegalDocument from '../../components/legal/LegalDocument';
import { privacyPolicyContent } from '../../content/legal/privacy-policy';

export default function PrivacyPolicyPage() {
  return (
    <LegalDocument title="Privacy Policy">
      {privacyPolicyContent}
    </LegalDocument>
  );
}
